export function map2MockId (arr) {
  return arr.map((item, i) => ({
    ...item,
    id: i + 1
  }))
}

export function applyDrag (arr, dragResult) {
  const { removedIndex, addedIndex, payload } = dragResult
  if (removedIndex === null && addedIndex === null) return arr

  const result = [...arr]
  let itemToAdd = payload

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0]
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd)
  }

  return result
}

export function getRange (length, start = 1) {
  return Array.from({ length })
    .map((_, i) => i + start)
}

export function getIds (array) {
  return array.map(item => item.id)
}
